export const firebaseConfig = {
  apiKey: "AIzaSyBbVJtps_gIU88oCIdA3k-qujSGbC4iPhE",
  authDomain: "storieshub.firebaseapp.com",
  projectId: "storieshub",
  storageBucket: "storieshub.appspot.com",
  messagingSenderId: "465909431732",
  appId: "1:465909431732:web:e429b65f695e9a46f6c6e1",
};
export const appName = "StoriesHub";
export const webUrl =
  process.env.NODE_ENV === "development"
    ? "localhost:3000"
    : "https://storieshub.web.app";
